module.exports = __webpack_public_path__ + "static/img/4.1552f76.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/4.png
// module id = T8Tf
// module chunks = 0